"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var roleApi = _interopRequireWildcard(require("@/api/role.js"));
var systemAdminApi = _interopRequireWildcard(require("@/api/systemadmin.js"));
var _validate = require("@/utils/validate");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/** 与后端 RegularConstants.ADMIN_PASSWORD 一致：8-20 位，字母+数字，可含 . _ - ! @ # $ & * */
var ADMIN_PASSWORD_PATTERN = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d._\-!@#$&*]{8,20}$/;
var ADMIN_PASSWORD_MESSAGE = '8-20位，必须有字母+数字，可配合常见符号如 . _ - ! @ # $ &';
var _default2 = exports.default = {
  components: {},
  props: {
    isCreate: {
      type: Number,
      required: true
    },
    editData: {
      type: Object,
      default: function _default() {
        return {
          rules: []
        };
      }
    }
  },
  data: function data() {
    var _this = this;
    var validatePass = function validatePass(rule, value, callback) {
      if (value === '') {
        callback(new Error('请再次输入密码'));
      } else if (value !== _this.pram.password) {
        callback(new Error('两次输入密码不一致!'));
      } else {
        callback();
      }
    };
    var validatePassword = function validatePassword(rule, value, callback) {
      if (!value) {
        callback(new Error('请填管理员密码'));
        return;
      }
      if (!ADMIN_PASSWORD_PATTERN.test(value)) {
        callback(new Error(ADMIN_PASSWORD_MESSAGE));
        return;
      }
      callback();
    };
    var validateRealName = function validateRealName(rule, value, callback) {
      var name = (value || '').trim();
      if (!name) {
        callback(new Error('请填写管理员姓名'));
        return;
      }
      if (name === '超级管理员') {
        callback(new Error('不能使用「超级管理员」作为姓名'));
        return;
      }
      callback();
    };
    var phonePattern = {
      pattern: /^1\d{10}$/,
      message: '请输入正确的手机号（1开头11位）',
      trigger: ['blur', 'change']
    };
    return {
      constants: this.$constants,
      pram: {
        account: null,
        password: null,
        repwd: null,
        realName: '',
        roleIds: [],
        status: true,
        id: null,
        phone: null
      },
      roleList: {
        recordList: []
      },
      rules: {
        account: [{
          required: true,
          message: '请填管理员手机号',
          trigger: ['blur', 'change']
        }, phonePattern],
        password: [{
          required: true,
          validator: validatePassword,
          trigger: ['blur', 'change']
        }],
        repwd: [{
          required: true,
          message: '确认密码密码',
          validator: validatePass,
          trigger: ['blur', 'change']
        }],
        realName: [{
          required: true,
          validator: validateRealName,
          trigger: ['blur', 'change']
        }],
        roleIds: [{
          required: true,
          type: 'array',
          min: 1,
          message: '请选择管理员角色',
          trigger: ['blur', 'change']
        }]
      }
    };
  },
  mounted: function mounted() {
    this.initEditData();
    this.handleGetRoleList();
  },
  methods: {
    close: function close() {
      this.$emit('hideEditDialog');
    },
    handleGetRoleList: function handleGetRoleList() {
      var _this2 = this;
      var _pram = {
        currentPage: 1,
        pageSize: this.constants.page.limit[4],
        status: 1
      };
      roleApi.getRoleList(_pram).then(function (data) {
        _this2.roleList = data || {
          recordList: []
        };
        var validIds = new Set((data.recordList || []).map(function (item) {
          return String(item.id);
        }));
        var selected = (_this2.pram.roleIds || []).map(String);
        _this2.$set(_this2.pram, 'roleIds', selected.filter(function (id) {
          return validIds.has(id);
        }));
      });
    },
    initEditData: function initEditData() {
      if (this.isCreate !== 1) return;
      var _this$editData = this.editData,
        account = _this$editData.account,
        realName = _this$editData.realName,
        roleIds = _this$editData.roleIds,
        status = _this$editData.status,
        id = _this$editData.id,
        phone = _this$editData.phone;
      this.pram.account = account;
      this.pram.realName = realName || '';
      // 雪花 ID 以字符串保留，避免 Number/parseInt 丢精度
      this.pram.roleIds = roleIds ? String(roleIds).split(',').map(function (s) {
        return s.trim();
      }).filter(Boolean) : [];
      this.pram.status = status;
      this.pram.id = id;
      this.pram.phone = phone || account;
      this.rules.password = [];
      this.rules.repwd = [];
    },
    buildPayload: function buildPayload() {
      return _objectSpread(_objectSpread({}, this.pram), {}, {
        phone: this.pram.phone || this.pram.account,
        roleIds: this.pram.roleIds
      });
    },
    handlerSubmit: (0, _validate.Debounce)(function (form) {
      var _this3 = this;
      this.$refs[form].validate(function (valid) {
        if (!valid) return;
        if (_this3.isCreate === 0) {
          _this3.handlerSave();
        } else {
          _this3.handlerEdit();
        }
      });
    }),
    handlerSave: function handlerSave() {
      var _this4 = this;
      systemAdminApi.adminAdd(this.buildPayload()).then(function () {
        _this4.$message.success('创建管理员成功');
        _this4.$emit('hideEditDialog');
      });
    },
    handlerEdit: function handlerEdit() {
      var _this5 = this;
      systemAdminApi.adminUpdate(this.buildPayload()).then(function () {
        _this5.$message.success('更新管理员成功');
        _this5.$emit('hideEditDialog');
      });
    },
    rulesSelect: function rulesSelect(selectKeys) {
      this.pram.rules = selectKeys;
    },
    handlerPwdInput: function handlerPwdInput(val) {
      var _this6 = this;
      if (!val) {
        this.rules.password = [];
        this.rules.repwd = [];
        return;
      }
      this.rules.password = [{
        required: true,
        validator: function validator(rule, value, callback) {
          if (!value) {
            callback(new Error('请填管理员密码'));
            return;
          }
          if (!ADMIN_PASSWORD_PATTERN.test(value)) {
            callback(new Error(ADMIN_PASSWORD_MESSAGE));
            return;
          }
          callback();
        },
        trigger: ['blur', 'change']
      }];
      this.rules.repwd = [{
        required: true,
        message: '两次输入密码不一致',
        validator: function validator(rule, value, callback) {
          if (value === '') {
            callback(new Error('两次输入密码不一致!'));
          } else if (value !== _this6.pram.password) {
            callback(new Error('两次输入密码不一致!'));
          } else {
            callback();
          }
        },
        trigger: ['blur', 'change']
      }];
    }
  }
};